import { useContext } from "react"
import { FeatureContext } from "../../../Context"
import { currency, percentage, lang } from "../../../Utils";

const LineDetailLine = ({ label, value, placeholder }) => (!!value || !!placeholder) ? <div className="bf-linedetail-box-line">
  <label>{label}</label>
  <span>{value || placeholder}</span>
</div> : null;

const LineDetailSection = ({ children }) => <div className="bf-linedetail-box-section">{children}</div>

const LineDetailBox = ({ title, name, children}) => <div className={`bf-linedetail-box ${name}`}>
  <div className="bf-linedetail-box-title">{title}</div>
  <div>{children}</div>
</div>

const LineDetail = () => {
  const context = useContext(FeatureContext);

  return <div className="bf-linedetail-wrapper">
    <LineDetailBox title={lang('Material Description')} name="mat-descr">
      <LineDetailSection>
        <LineDetailLine label={lang('Material ID')} value={context?.detail?.bonfiglioliMaterialNumber} placeholder="-"/>
        <LineDetailLine label={lang('Customer Material ID')} value={context?.detail?.customerMaterialNumber} placeholder="-" />
        <LineDetailLine label={lang('Designation')} value={context?.detail?.description} placeholder="-"/>
      </LineDetailSection>
    </LineDetailBox>

    <LineDetailBox title={lang('Pricing Description')} name="price-descr">
      <LineDetailSection>
        <LineDetailLine label={lang('Net Unit Price with Surcharge')} value={currency(context?.detail?.netPrice, context?.detail?.currency)} placeholder="0" />
        <LineDetailLine label={lang('Temporary Surcharge %')} value={percentage(context?.detail?.surchargePercentage)} placeholder="0"/>
        <LineDetailLine label={lang('Ordered Qty')} value={context?.detail?.quantity} placeholder="0" />
      </LineDetailSection>

      <LineDetailSection>
        <LineDetailLine label={lang('Packaging')} value={currency(context?.detail?.packagingAmount, context?.detail?.currency)} placeholder="0" />
        <LineDetailLine label={lang('Transport')} value={currency(context?.detail?.transportAmount, context?.detail?.currency)} placeholder="0" />
      </LineDetailSection>

      <LineDetailSection>
        <LineDetailLine label={lang('Urgency')} value={context?.detail?.urgencyAmount} />
        <LineDetailLine label={lang('Urgency')} value={context?.detail?.fixedUrgencyAmount} />
      </LineDetailSection>

      <LineDetailSection>
        {(context?.detail?.surchargeAmount !== 0) ? <LineDetailLine label={lang('Total Temporary Surcharge')} value={currency(context?.detail?.surchargeAmount, context?.detail?.currency)} placeholder="0"/> : null}
        <LineDetailLine label={lang('Total Price with Surcharge')} value={currency(context?.detail?.totalNetPrice, context?.detail?.currency)} placeholder="0"/>
      </LineDetailSection>
    </LineDetailBox>

    <LineDetailBox title={lang('Quantity')} name="qty-descr">
      <LineDetailSection>
        <LineDetailLine label={lang('Confirmed Qty')} value={context?.detail?.qtyconfirmed} placeholder="0" />
        <LineDetailLine label={lang('Shipped Qty')} value={context?.detail?.qtyshipped} placeholder="0"/>
        <LineDetailLine label={lang('Billed Qty')} value={context?.detail?.qtybilled} placeholder="0"/>
      </LineDetailSection>
    </LineDetailBox>
  </div>
}

export default LineDetail;